<template>
  <v-container fluid class="pa-0 ma-0">
    <v-dialog v-if="_isMobile()" v-model="emailModel" fullscreen persistent>
      <vetalfa-email-component></vetalfa-email-component>
    </v-dialog>
    <v-btn
      v-if="!_isMobile()"
      class="primary--text white text-none px-12 mr-14 mt-14"
      style="z-index: 1"
      fixed
      right
      rounded
      top
      large
      @click="contactUs"
    >
      Ajuda
    </v-btn>
    <v-layout fill-height class="login-background">
      <v-img
        v-if="_isMobile()"
        :src="welcomeMobile"
        class="login-background-image"
        aspect-ratio="1"
      ></v-img>
      <v-img
        v-else
        :src="welcome"
        class="login-background-desktop-image"
        aspect-ratio="1"
      ></v-img>
      <div class="login-gradient-layer" v-if="_isMobile()"></div>
      <v-col class="login-bottom-align" v-if="_isMobile()">
        <v-row no-gutters align="end" justify="center">
          <v-col cols="10" class="ml-n2" no-gutters>
            <v-img :src="logoWhite" contain width="30%"></v-img>
          </v-col>
          <v-col cols="10" class="mt-3" no-gutters>
            <span
              class="white--text font-weight-bold title"
              style="line-height: 20px"
              >O seu suporte</span
            >
          </v-col>
          <v-col cols="10" no-gutters>
            <span
              class="white--text font-weight-bold title"
              style="line-height: 20px"
              >à decisões</span
            >
          </v-col>
          <v-col cols="10" no-gutters>
            <span
              class="white--text font-weight-bold title"
              style="line-height: 20px"
              >clínicas</span
            >
          </v-col>
          <v-col cols="8" class="mt-16">
            <v-btn
              @click="openEmailDialog"
              x-large
              class="white primary--text"
              rounded
              block
            >
              <span class="text-none font-weight-normal text-h6">Começar</span>
            </v-btn>
          </v-col>
          <v-col cols="8" class="mt-4 px-3">
            <v-row justify="space-between" no-gutters>
              <span
                class="white--text caption text-decoration-underline vetalfa-pointer"
                @click="contactUs"
                >Suporte</span
              ><span
                class="white--text caption text-decoration-underline vetalfa-pointer"
                @click="
                  openExternalUrl({
                    url: _getParameter('TERMS_URL'),
                    inAppBrowser: true,
                  })
                "
                >Termos e Políticas</span
              >
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else>
        <v-row no-gutters justify="center">
          <v-col no-gutters cols="12">
            <v-row justify="center" class="pa-0 ma-0 mt-14">
              <v-img
                :src="logoSmall"
                contain
                width="40px"
                height="40px"
              ></v-img>
            </v-row>
            <v-row justify="center" class="pa-0 ma-0 mt-8 mb-14">
              <p class="pa-0 ma-0 white--text text-6 font-weight-bold">
                Olá, boas-vindas ao Vet Alfa
              </p>
            </v-row>
          </v-col>
          <vetalfa-email-component></vetalfa-email-component>
          <v-col no-gutters cols="12">
            <v-row justify="center" class="pa-0 ma-0 mt-7">
              <p
                class="pa-0 ma-0 white--text caption"
                style="line-height: 12px"
              >
                {{ _getLabel("LOGIN_FOOTER_TEXT_1") }}
              </p>
            </v-row>
            <v-row justify="center" class="pa-0 ma-0">
              <p
                class="pa-0 ma-0 white--text caption"
                style="line-height: 12px"
              >
                <span
                  @click="
                    openExternalUrl({
                      url: _getParameter('TERMS_URL'),
                      inAppBrowser: true,
                    })
                  "
                  class="pa-0 ma-0 vetalfa-pointer"
                  style="text-decoration: underline !important"
                  >{{ _getLabel("USE_TERMS_TITLE") }}</span
                >
                <span>{{ _getLabel("LOGIN_FOOTER_TEXT_2") }}</span>
                <span
                  @click="
                    openExternalUrl({
                      url: _getParameter('POLICIES_URL'),
                      inAppBrowser: true,
                    })
                  "
                  class="pa-0 ma-0 vetalfa-pointer"
                  style="text-decoration: underline !important"
                  >{{ _getLabel("PRIVACY_POLICIES_TITLE") }}</span
                >
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-layout>
  </v-container>
</template>

<style>
.login-background {
  position: relative !important;
  background: linear-gradient(93.06deg, #193153 0.76%, #193153 99.04%);
}
.login-background-image {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
  min-width: 100%;
  z-index: 0;
}
.login-background-desktop-image {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
  max-width: 40%;
  mix-blend-mode: lighten;
  z-index: 0;
  -webkit-mask-image: linear-gradient(to right, black 75%, transparent 100%);
  mask-image: linear-gradient(to right, black 75%, transparent 100%);
}
.login-gradient-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #193153 0%, #02738b 100%);
  mix-blend-mode: multiply;
  z-index: 0;
}
.login-bottom-align {
  position: absolute;
  bottom: 10%;
}
</style>

<script>
import { mdiEmailOutline } from "@mdi/js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import images from "@/constants/images.js";
import Email from "@/components/Email.vue";
export default {
  name: "Login",
  watch: {
    "$route.query.support"() {
      this.openSupportFromQuery();
    },
  },
  methods: {
    openSupportFromQuery() {
      if (this.$route.query.support === "1") {
        this.$store.dispatch("support/open");
      }
    },
    ...mapMutations("general", ["setEmailConfirmation"]),
    ...mapActions("general", [
      "openEmailDialog",
      "openExternalUrl",
      "contactUs",
    ]),
  },
  components: {
    "vetalfa-email-component": Email,
  },
  computed: {
    ...mapGetters("general", ["emailConfirmation"]),
    emailModel: {
      get() {
        return this.emailConfirmation;
      },
      set(val) {
        this.setEmailConfirmation(val);
      },
    },
  },
  data() {
    return {
      logo: images.LOGO_LOGIN,
      logoWhite: images.LOGO_SMALL_HEADER_WHITE,
      welcomeMobile: images.WELCOME_MOBILE,
      welcome: images.WELCOME,
      logoSmall: images.LOGO_SMALL_HEADER_MOBILE,
      mdiEmailOutline,
    };
  },
  mounted() {
    this.setEmailConfirmation(false);
    this.openSupportFromQuery();
  },
  created() {},
};
</script>
